// extracted by mini-css-extract-plugin
export var searchHeader = "_6e-0";
export var searchHeaderDark = "_6e-1";